import { useEffect } from 'react';

import { useAuth } from './useAuth.jsx';

const MICROSOFT_UET_SCRIPT_ID = 'microsoft-uet-script';

const initializeMicrosoftUET = (tagId: string) => {
  if (window.__microsoftUetInitialized || !window.UET) {
    return;
  }

  const queuedEvents = Array.isArray(window.uetq) ? window.uetq : [];
  const uet = new window.UET({
    ti: tagId,
    enableAutoSpaTracking: true,
    q: queuedEvents,
  });

  window.uetq = uet;
  window.__microsoftUetInitialized = true;
  window.uetq.push('pageLoad');
};

export const useMicrosoftUET = () => {
  const { user } = useAuth();

  useEffect(() => {
    // If user is authenticated, we skip loading Microsoft UET.
    if (Boolean(user)) {
      return;
    }

    const tagId = import.meta.env.VITE_APP_MICROSOFT_UET_TAG_ID;

    if (!tagId) {
      return;
    }

    if (!window.uetq) {
      window.uetq = [];
    }

    const existingScript = document.getElementById(MICROSOFT_UET_SCRIPT_ID);
    if (existingScript) {
      if (window.UET) {
        initializeMicrosoftUET(tagId);
        return;
      }

      existingScript.addEventListener(
        'load',
        () => {
          initializeMicrosoftUET(tagId);
        },
        { once: true },
      );
      return;
    }

    const script = document.createElement('script');
    script.id = MICROSOFT_UET_SCRIPT_ID;
    script.src = 'https://bat.bing.net/bat.js';
    script.async = true;
    script.onload = () => {
      initializeMicrosoftUET(tagId);
    };
    script.onerror = () => {
      console.warn('[Microsoft UET] Failed to load bat.js — tracking will be unavailable');
    };
    document.head.appendChild(script);
  }, [user]);
};
